import React from "react";
import { Button, Icon } from "semantic-ui-react";
import { InspectionItemStatus, InspectionItemStatuses } from "./InspectionItemStatus";
import InspectionItemStaffPassedDropdownButton from "./InspectionItemStaffPassedDropdownButton";
import InspectionItemStaffFailedDropdownButton from "./InspectionItemStaffFailedDropdownButton";
import InspectionItemStaffPassFailButtons from "./InspectionItemStaffPassFailButtons";
import { UserType, UserTypes } from "./InspectionItemUserType";

interface InspectionItemPassFailButtonProps {
  user: UserType;
  status: InspectionItemStatus;
  isInspectionComplete?: boolean;
  onFail: () => void;
  isPassLoading: boolean;
  onPass: () => void;
  isFailLoading: boolean;
}
export default function InspectionItemPassFailButton({
  user,
  status,
  isInspectionComplete,
  onFail,
  isFailLoading,
  onPass,
  isPassLoading,
}: InspectionItemPassFailButtonProps) {
  if (user === UserTypes.STAFF && status === InspectionItemStatuses.EMPTY && !isInspectionComplete) {
    return (
      <InspectionItemStaffPassFailButtons
        onFail={onFail}
        onPass={onPass}
        isFailLoading={isFailLoading}
        isPassLoading={isPassLoading}
      />
    );
  }
  if (user === UserTypes.STAFF && status === InspectionItemStatuses.FAILED && !isInspectionComplete) {
    return <InspectionItemStaffFailedDropdownButton onPass={onPass} isPassLoading={isPassLoading} />;
  }
  if (user === UserTypes.CITIZEN && status === InspectionItemStatuses.FAILED && !isInspectionComplete) {
    return <InspectionItemCitizenFailedButton />;
  }
  if (user === UserTypes.STAFF && status === InspectionItemStatuses.PASSED && !isInspectionComplete) {
    return <InspectionItemStaffPassedDropdownButton onFail={onFail} isFailLoading={isFailLoading} />;
  }
  if (user === UserTypes.CITIZEN && status === InspectionItemStatuses.PASSED && !isInspectionComplete) {
    return <InspectionItemCitizenPassedButton />;
  }
  if (status === InspectionItemStatuses.PASSED && isInspectionComplete) {
    return <InspectionItemPassedIcon />;
  }
  if (status === "failed" && isInspectionComplete) {
    return <InspectionItemFailedIcon />;
  }

  return <></>;
}

function InspectionItemPassedIcon() {
  return <Icon size='large' color='green' name='check' />;
}

function InspectionItemFailedIcon() {
  return <Icon size='large' color='red' name='cancel' />;
}

function InspectionItemCitizenFailedButton() {
  return (
    <Button className={`passed-failed-dropdown failed tw-bg-[#DF0202]`} inverted size='tiny'>
      Failed
    </Button>
  );
}

function InspectionItemCitizenPassedButton() {
  return (
    <Button className={`passed-failed-dropdown tw-bg-[#067E30]`} inverted size='tiny'>
      Passed
    </Button>
  );
}
